import store from "@/store";

const isGameFavorite = (lobby, gameKey) => {
  //? 0 - Não favorito || 1 - Favorito
  const gamesFavorites = JSON.parse(localStorage.getItem("gamesFavorites"));
  const userId = store.state.userId;

  if (!gamesFavorites || !gamesFavorites[userId]) return 0;
  
  if (gamesFavorites[userId][lobby][gameKey]) {
    return 1;
  } else {
    return 0;
  }
};

const listGamesFavorites = (lobby) => {
  const gamesFavorites = JSON.parse(localStorage.getItem("gamesFavorites"));
  const userId = store.state.userId;

  if (!gamesFavorites || !gamesFavorites[userId]) return [];

  return Object.entries(gamesFavorites[userId][lobby]).map((game) => game[1]);
};

const addGameFavorite = (lobby, game) => {
  let gamesFavorites = JSON.parse(localStorage.getItem("gamesFavorites"));
  const userId = store.state.userId;

  store.commit("setGamesFavoritesUpdating", true);

  if (!gamesFavorites || !gamesFavorites[userId]) {
    const localStorageSetup = {
      ...(gamesFavorites ? gamesFavorites : {})
    };

    localStorageSetup[userId] = {
      casino: {},
      live: {},
    };

    localStorage.setItem("gamesFavorites", JSON.stringify(localStorageSetup));

    gamesFavorites = JSON.parse(localStorage.getItem("gamesFavorites"));
  }

  gamesFavorites[userId][lobby][game.key] = game;
  localStorage.setItem("gamesFavorites", JSON.stringify(gamesFavorites));

  setTimeout(() => {
    store.commit("setGamesFavoritesUpdating", false);
  }, 100);
};

const removeGameFavorite = (lobby, gameKey) => {
  const gamesFavorites = JSON.parse(localStorage.getItem("gamesFavorites"));
  const userId = store.state.userId;

  store.commit("setGamesFavoritesUpdating", true);

  delete gamesFavorites[userId][lobby][gameKey];
  localStorage.setItem("gamesFavorites", JSON.stringify(gamesFavorites));

  setTimeout(() => {
    store.commit("setGamesFavoritesUpdating", false);
  }, 100);
};

export {
  isGameFavorite,
  listGamesFavorites,
  addGameFavorite,
  removeGameFavorite,
};